import React, { Component } from 'react'
import { connect }  from 'react-redux'

import './recruiment.scss'
class Recruitment extends Component {
  static title = '账户充值';
  state={
    phoneTip: false,
    showModal: false
  }

  componentDidMount(){
    let { router, user } = this.props
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    )
  }
}
export default Recruitment



// WEBPACK FOOTER //
// ./modules/recruitment/recruitment.js